import { Base_Url, Base_Url2 } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
  postApiWithoutAuthorization,
} from "../ApiMethods/ApiMethod";

const Url = `${Base_Url}`;

export const GetDivisionalCategoryList = async (params) => {
  const res = await postApiWithAuthorization(
    `${Url}/DivisionalCategory/GetDivisionCategoryList`,
    params
  );
  return res;
};

export const GetDivisionalCategoryModelData = async (UserKeyID) => {

  const res = await getApiWithAuthorization(
    `${Url}/DivisionalCategory/GetDivisionalCategoryModel?DivisionalCategoryKeyID=${UserKeyID}`
  );
  return res;
};

export const AddUpdateDivisionalCategory = async (requestJson) => {
  const res = await postApiWithAuthorization(
    `${Url}/DivisionalCategory/AddUpdateDivisionCategory`, requestJson
  );
  return res;
};

export const AddDivisionalCategoryDocumentType = async (requestJson) => {
  const res = await postApiWithAuthorization(
    `${Url}/DivisionalCategory/AddDivisionalCategoryDocumentType`, requestJson
  );
  return res;
};

export const GetUnassignedDocumentTypeList = async (DivisionalCategoryID) => {
  const res = await getApiWithAuthorization(
    `${Url}/DivisionalCategory/GetUnassignedDocumentTypeList?DivisionalCategoryID=${DivisionalCategoryID}`
  );
  return res;
};

export const GetAssignedDocumentTypeList = async (DivisionalCategoryID) => {
  const res = await getApiWithAuthorization(
    `${Url}/DivisionalCategory/GetAssignedDocumentTypeList?DivisionalCategoryID=${DivisionalCategoryID}`
  );
  return res;
};

export const DeleteDivisionalCategoryDocumentType = async (DivisionalCategoryDocumentTypeKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/DivisionalCategory/DeleteDivisionalCategoryDocumentType?DivisionalCategoryDocumentTypeKeyID=${DivisionalCategoryDocumentTypeKeyID}`
  );
  return res;
};

export const UpdateDivisionalCategoryStatus = async (divisionalCategoryKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/DivisionalCategory/ChangeDivisionalCategoryStatus?DivisionalCategoryKeyID=${divisionalCategoryKeyID}`
  );
  return res;
};

export const DeleteClient = async (ModuleName, KeyID, UserKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/DeleteClient?ModuleName=${ModuleName}&ClientKeyID=${KeyID}&UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetClientProjectLookupList = async (UserKeyID, ClientKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/GetClientProjectLookupList?UserKeyID=${UserKeyID}&ClientKeyID=${ClientKeyID}`
  );
  return res;
};

export const GetClientProjectLookupListReport = async (
  ModuleName,
  UserKeyID
) => {
  const res = await getApiWithAuthorization(
    `${Url}/GetClientProjectLookupList?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}`
  );
  return res;
};

export const GetClientDetails = async (UserKeyID, ClientKeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/GetClientDetails?UserKeyID=${UserKeyID}&ClientKeyID=${ClientKeyID}`
  );
  return res;
};
export const GetClientLookupList = async (ModuleName, KeyID) => {
  const res = await getApiWithAuthorization(
    `${Url}/GetClientLookupList?ModuleName=${ModuleName}&UserKeyID=${KeyID}`
  );
  return res;
};
export const GetDivisionalCategoryLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Url}/DivisionalCategory/GetDivisionalCategoryLookupList`
  );
  return res;
};



export const GetStateLookupList = async () => {
  const res = await getApiWithAuthorization(
    `${Url}/State/GetStateLookupList`
  );
  return res;
};